export interface KngFooter {
  state: KngFooterState;
}

export interface KngFooterState {
  ribbonImage: string;
  altText: string;
  footercontent: KngFooterData;
  cssClass: string;
}
export interface KngFooterData {
  css: {
    ecomm: string;
  };
  script: {};
  unifiedFooter: string;
}
export interface KngFooterMenu {
  id: string;
  label: string;
  iconPath: string;
  altText: string;
  labelValue: string[];
  url?: string;
}
export interface KngFooterCopyRight {
  label: string;
  labelUrl: KngFooterCopyRightLabel[];
}
export interface KngFooterCopyRightLabel {
  label: string;
  url: string;
}
export interface KngFooterLogoUrl {
  label: string;
  url: string;
}
export enum FooterLabel {
  phone = 'Phone',
  email = 'Email',
  support = 'Support',
  usa = '',
  country = 'Select a Country/Language',
}
